import { render, staticRenderFns } from "./distributionReport.vue?vue&type=template&id=b57b7a40&scoped=true&"
import script from "./distributionReport.vue?vue&type=script&lang=js&"
export * from "./distributionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57b7a40",
  null
  
)

export default component.exports